import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Body2, ChooseV2 } from "@activecollab/components";
import PropTypes from "prop-types";
import { CopySnippet } from "~/components/CopyToClipboard/CopySnippet";

const OPTIONS = [
  {
    id: "curl",
    name: "cURL",
  },
  {
    id: "typescript",
    name: "TypeScript",
  },
  {
    id: "postman",
    name: "Postman",
  },
];

export const ApiTokenUsageExample = ({ apiUrl, token }) => {
  const { t } = useTranslation();
  const [selected, setSelected] = useState([]);

  const CODE_EXAMPLES = {
    curl: {
      description: `curl -X GET ${apiUrl}/info \\
  -H "Authorization: Bearer ${token}"`,
      title: t("Run this in your terminal"),
    },
    typescript: {
      description: `import axios from 'axios';

const apiToken = '${token}';
const response = await axios.get('${apiUrl}/info', {
  headers: {
    'Authorization': \`Bearer \${apiToken}\`,
  },
});`,
      title: t("Run this script"),
    },
    postman: { title: t("Run this in Postman") },
  };

  const codeContent = selected.length ? CODE_EXAMPLES[selected[0]]?.description : null;

  return (
    <div>
      <div className="tw-mb-6">
        <Body2
          className="tw-mb-2"
          weight="bold"
        >
          {t("Make your first request")}
        </Body2>
        <ChooseV2
          options={OPTIONS}
          selected={selected}
          onChange={setSelected}
        />
      </div>
      {!!selected.length && (
        <>
          <div className="tw-mb-6">
            <Body2
              className="tw-mb-2"
              weight="bold"
            >
              {CODE_EXAMPLES[selected[0]]?.title}
            </Body2>
            {selected[0] === "postman" ? (
              <img
                src="/assets/system/images/integrations/postman_example.png"
                alt={t("Postman example")}
                className="tw-max-w-full tw-h-auto"
              />
            ) : (
              <CopySnippet codeContent={codeContent} />
            )}
          </div>
          <div className="tw-mb-6">
            <Body2
              weight="bold"
              className="tw-mb-2"
            >
              {t("You should get")}
            </Body2>
            <CopySnippet
              codeContent={`{
  "application": "ActiveCollab",
  "version": "X.Y.Z"
}`}
              hideCopyButton
            />
          </div>
        </>
      )}
    </div>
  );
};

ApiTokenUsageExample.propTypes = {
  apiUrl: PropTypes.string,
  token: PropTypes.string,
};
